// Globals
import { FC } from 'react';

// Modules
import { ImportFaqModal } from '@/modules/FaqCommon';

// Store
import { useAppDispatch } from '@/store';
import { getFaqs } from '../feature';

type TImportChannelFaqModalProps = {
  isOpen: boolean;
  onClose: () => void;
  channelId: number;
};

const ImportChannelFaqModal: FC<TImportChannelFaqModalProps> = ({ isOpen, onClose, channelId }) => {
  const dispatch = useAppDispatch();

  const handleImported = () => {
    dispatch(getFaqs({ channelId, page: 1 }));
  };

  return <ImportFaqModal isOpen={isOpen} onClose={onClose} onImported={handleImported} channelId={channelId} />;
};

export default ImportChannelFaqModal;
